import { defineAsyncComponent } from "vue";
import { getI18n } from "@editor/ui-utils";
const de = {
  inpage: {
    contentBlockLabel: "Inpage Widget",
    titleInputLabel: "Datawrapper-Titel",
    brandSelectorLabel: "Marke",
    editInpageWidget: "",
    backButton: "Zurück zur Inpage widget",
    newInpageWidget: "Neues Inpage-Widget",
    messageDeleteInpageWidget: "",
    messageDeleteInpageWidgetTitle: "",
    deleteInpageWidget: "Löschen",
    messageDeleted: "Inpage widget gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des Inpage widget",
    errorFailedLoadedDatawrapperWithId: "Es gab einen Fehler beim Abrufen des Inpage widget",
    select: "Inpage-Widget auswählen"
  },
  inpageList: {
    newButton: "Neues Inpage-Widget",
    search: "Nach Widget-Name oder -Anbieter suchen",
    provider: "Anbieter",
    license: "Lizenz",
    title: "Widget-Name",
    deleteInpageWidget: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade Inpage Widget",
    description: "Beschreibung",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createInpageWidget: "Inpage Widget erstellen",
    allBrands: "Alle Marken"
  },
  inpageEdit: {
    title: "Widget-Name",
    preview: "Vorschau",
    provider: "Anbieter",
    html: "Quellcode",
    consent: "Braucht Zustimmung",
    adLabel: "Als Anzeige markieren",
    markAffiliate: "Als Affiliate markieren",
    license: "Lizenz",
    backButton: "Zurück zur CTA Button-Liste",
    editInpageWidgetButton: "Inpage widget Button bearbeiten",
    messageSaved: "Deine Änderungen wurden gespeichert. Um das Inpage-Widget in einem Artikel anzuzeigen, füge es dem gewünschten Artikel hinzu.",
    showPreview: "Vorschau Anzeigen",
    hidePreview: "Vorschau Nicht Anzeigen",
    validate: "Validieren & Vorschau Zeigen",
    invalidHtml: "Die Validierung des Widget-Quellcodes ist fehlgeschlagen!"
  }
};
const en = {
  inpage: {
    contentBlockLabel: "Inpage Widget",
    titleInputLabel: "Datawrapper title",
    brandSelectorLabel: "Brand",
    editInpageWidget: "Edit list",
    backButton: "Back to Inpage widget list",
    newInpageWidget: "New Inpage Widget",
    messageDeleteInpageWidget: "Delete Inpage widget",
    messageDeleteInpageWidgetTitle: "Are you sure you want to delete this Inpage widget?",
    deleteInpageWidget: "Delete",
    messageDeleted: "Inpage Widget Deleted",
    errorOnDeleting: "There was an error deleting the Inpage widget ",
    errorFailedLoadedDatawrapperWithId: "There was an error getting the Inpage widget",
    select: "Select Inpage Widget"
  },
  inpageList: {
    newButton: "New Inpage Widget",
    search: "Search by widget name or provider",
    provider: "Provider",
    license: "License",
    title: "Widget Title",
    deleteInpageWidget: "Delete",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading Inpage Widget",
    description: "Description",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createInpageWidget: "Create Inpage Widget",
    allBrands: "All brands"
  },
  inpageEdit: {
    title: "Widget title",
    preview: "Preview",
    provider: "Provider",
    html: "Source code",
    consent: "Needs consent",
    adLabel: "Mark as ad",
    markAffiliate: "Mark as affiliate",
    license: "License",
    backButton: "Back to CTA Button list",
    editInpageWidgetButton: "Edit Inpage Widget",
    messageSaved: "Your changes have been saved. To display the Inpage Widget in an article, add it to the desired article.",
    showPreview: "Show Preview",
    hidePreview: "Hide Preview",
    validate: "Validate & Show preview",
    invalidHtml: "The widget source code validation was not successful!"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/inpage",
    children: [
      {
        path: "",
        name: "inpage_list",
        component: () => import("./inpage-list.view-B2lWuaqt.js"),
        meta: { requiredRight: "navigate_list_inpage_widget" }
      },
      {
        path: "new",
        name: "inpage_new",
        component: () => import("./inpage-edit.view-CzZvIpqX.js").then((n) => n.i),
        props: () => ({
          title: getI18n().t("inpage.newInpageWidget"),
          backRoute: "/inpage"
        }),
        meta: { requiredRight: ["navigate_inpage_widget"] }
      },
      {
        path: ":id",
        name: "inpage_detail",
        component: () => import("./inpage-edit.view-CzZvIpqX.js").then((n) => n.i),
        props: (route) => ({
          title: getI18n().t("inpageEdit.editInpageWidgetButton"),
          id: route.params.id,
          backRoute: "/inpage"
        }),
        meta: { requiredRight: ["navigate_inpage_widget"] }
      }
    ]
  }
];
const InpageWidgetContentBlock = defineAsyncComponent(() => import("./inpage-article-block-VwgKyEwB.js"));
const ChannelInpageWidgetBlock = defineAsyncComponent(() => import("./inpage-channel-block-DOOqaEgY.js"));
const inpageWidgetModule = {
  messages,
  routes,
  contentBlocks: [
    {
      type: "INPAGE_WIDGET",
      label: "inpage.contentBlockLabel",
      icon: "file-text",
      component: InpageWidgetContentBlock,
      defaultValue: { type: "INPAGE_WIDGET" }
    }
  ]
};
export {
  ChannelInpageWidgetBlock,
  InpageWidgetContentBlock,
  inpageWidgetModule
};
//# sourceMappingURL=index.es.js.map
